import { render, staticRenderFns } from "./book.html?vue&type=template&id=2eb45d48&scoped=true&"
import script from "./book.js?vue&type=script&lang=js&"
export * from "./book.js?vue&type=script&lang=js&"
import style0 from "./book.sass?vue&type=style&index=0&id=2eb45d48&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb45d48",
  null
  
)

component.options.__file = "book.vue"
export default component.exports